import PropTypes from "prop-types"
import React from "react"

import { useTranslate } from "context/translateContext"
import Alert from "shared/components/Alert"
import AlertIcon from "shared/components/AlertIcon"

const LegacyPlanAlert = props => {
  const { t: translate } = useTranslate()
  const { legacyPlanName } = props

  return (
    legacyPlanName && (
      <Alert type="info" className="m-t-30">
        <div className="flex-container f-a-center">
          <AlertIcon type="info" />
          <div className="m-l-10">
            <p className="c-black no-m ">
              {translate("You're currently on our {legacyPlan} legacy plan.", {
                legacyPlan: legacyPlanName.toUpperCase(),
              })}
            </p>
            <p className="no-m w300">
              {translate(
                "Please find below our new plan. Please contact us for more details."
              )}
            </p>
          </div>
        </div>
      </Alert>
    )
  )
}

LegacyPlanAlert.propTypes = {
  legacyPlanName: PropTypes.string,
}

LegacyPlanAlert.defaultProps = {
  legacyPlanName: null,
}

export default LegacyPlanAlert
